/* eslint-disable camelcase */
import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PerformanceDetails from './performance-details';
import BonusDetails from './bonus-details';
import FurtherInformation from './further-information';

class IncentivePerformance extends Component {
  render() {
    const {
      incentive, correct_to_date, current_user, outlet
    } = this.props;

    return (
      <div className={`incentive-performance ${incentive.locked ? 'locked' : ''}`}>
        <h2>
          {incentive.locked && (
            <OverlayTrigger
              placement="left"
              overlay={(
                <Tooltip id="tooltip" className="tooltip">
                  This incentive is now closed and you can no longer earn points for selling these products.
                  Any points earned that have not yet been awarded will be awarded as soon as possible.
                </Tooltip>
              )}
            >
              <span className="glyphicon glyphicon-lock" aria-hidden="true"></span>
            </OverlayTrigger>
          )}
          {incentive.name}
        </h2>
        <PerformanceDetails current_user={current_user} incentive={incentive} correct_to_date={correct_to_date} />
        { incentive.bonus_points_enabled && <BonusDetails current_user={current_user} incentive={incentive} outlet={outlet} /> }
        <FurtherInformation current_user={current_user} incentive={incentive} outlet={outlet} />
      </div>
    );
  }
}

export default IncentivePerformance;



// WEBPACK FOOTER //
// ./src/components/store-performance/sell-it/incentive-performance.jsx